// extracted by mini-css-extract-plugin
export default {"container":"app-qr-code_container__mhk-w","card":"app-qr-code_card__lAe1h","logoImage":"app-qr-code_logoImage__v4O-c","qrImage":"app-qr-code_qrImage__JePRS"};